import { render, staticRenderFns } from "./appIngList.vue?vue&type=template&id=1347fe4a&scoped=true"
import script from "./appIngList.vue?vue&type=script&lang=js"
export * from "./appIngList.vue?vue&type=script&lang=js"
import style0 from "./appIngList.vue?vue&type=style&index=0&id=1347fe4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347fe4a",
  null
  
)

export default component.exports